import React from 'react';
import T from 'prop-types';

import Tooltip from '../../../Tooltip';
import Button from '../../../Buttons/Button';
import { Menu, MenuItem, useMenuProps } from '../../../DropdownSet';
import { SCHEDULED_EXPORTS_LIMIT } from '../../configs/constants';

const FormActions = ({
  formMode,
  isSubmitDisabled = false,
  isSaveDisabled = false,
  noCrossAppSPairsSelected = false,
  scheduleLimitReached = false,
  allowSchedulingProgress = false,
  isModal,
  onSubmit,
  onOpenModalConfirm,
  onOpenNameModal,
  onOpenScheduleModal,
}) => {
  const renderGenerateButton = ({ generateAction }) => (
    <Tooltip
      content={
        isSubmitDisabled &&
        noCrossAppSPairsSelected &&
        'Please select at least one app pairing for your Cross-App Datapoints'
      }
      wrapChildrenInHtmlNode
    >
      <Button disabled={isSubmitDisabled} onClick={generateAction}>
        Generate Export
      </Button>
    </Tooltip>
  );
  return (
    <div className="global-upsert-export-modal__footer-buttons">
      {formMode === 'update' &&
        renderGenerateButton({
          generateAction: onOpenModalConfirm,
        })}
      {formMode === 'create' &&
        (allowSchedulingProgress ? (
          <div className="split-dropdown-button">
            {renderGenerateButton({
              generateAction: () =>
                onSubmit({ action: 'create', one_time: true, should_redirect: !isModal }),
            })}
            <div className="separator" />
            <GenerateSubActionsDropdown
              isSubmitDisabled={isSubmitDisabled}
              isSaveDisabled={isSaveDisabled}
              scheduleLimitReached={scheduleLimitReached}
              onOpenNameModal={onOpenNameModal}
              onOpenScheduleModal={onOpenScheduleModal}
            />
          </div>
        ) : (
          <>
            {renderGenerateButton({
              generateAction: () =>
                onSubmit({ action: 'create', one_time: true, should_redirect: !isModal }),
            })}
            <Tooltip
              content={
                (isSubmitDisabled || isSaveDisabled) &&
                "Advanced export settings cannot be saved during your trial period. You can continue with a one-time export by using the 'Generate Export'"
              }
              wrapChildrenInHtmlNode
            >
              <Button
                variant="secondary"
                disabled={isSubmitDisabled || isSaveDisabled}
                onClick={onOpenNameModal}
              >
                Generate & Save Export Settings
              </Button>
            </Tooltip>
          </>
        ))}
    </div>
  );
};

FormActions.propTypes = {
  formMode: T.string,
  isSubmitDisabled: T.bool,
  onSubmit: T.func.isRequired,
  isSaveDisabled: T.bool,
  isModal: T.bool,
  noCrossAppSPairsSelected: T.bool,
  scheduleLimitReached: T.bool,
  allowSchedulingProgress: T.bool,
  onOpenModalConfirm: T.func.isRequired,
  onOpenNameModal: T.func.isRequired,
  onOpenScheduleModal: T.func.isRequired,
};

export default FormActions;

const trialTTContent =
  "Advanced export settings cannot be saved during your trial period. You can continue with a one-time export by using the 'Generate Export'";
const scheduledLimitTTContent = `You have reached your maximum allowed scheduled exports (${SCHEDULED_EXPORTS_LIMIT})`;

function GenerateSubActionsDropdown({
  isSubmitDisabled,
  isSaveDisabled,
  scheduleLimitReached,
  onOpenNameModal,
  onOpenScheduleModal,
}) {
  const menuProps = useMenuProps({
    align: 'end',
    menuStyle: { width: 204 },
  });

  const isDisabled = isSubmitDisabled || isSaveDisabled;

  return (
    <Menu
      menuButton={
        <Button shape="square" disabled={isSubmitDisabled}>
          <span className="hicon-angle-down-new" />
        </Button>
      }
      {...menuProps}
    >
      <Tooltip content={isDisabled && trialTTContent} wrapChildrenInHtmlNode>
        <MenuItem className="menu-item--14" onClick={onOpenNameModal}>
          Save Settings & Export
        </MenuItem>
      </Tooltip>
      <Tooltip
        content={(() => {
          if (isDisabled) return trialTTContent;
          if (scheduleLimitReached) return scheduledLimitTTContent;
          return null;
        })()}
        colorVariant="light"
      >
        <MenuItem
          className="menu-item--14"
          disabled={scheduleLimitReached}
          onClick={() => !scheduleLimitReached && onOpenScheduleModal()}
        >
          Save Settings & Schedule
        </MenuItem>
      </Tooltip>
    </Menu>
  );
}

GenerateSubActionsDropdown.propTypes = {
  isSubmitDisabled: T.bool.isRequired,
  isSaveDisabled: T.bool.isRequired,
  scheduleLimitReached: T.bool.isRequired,
  onOpenNameModal: T.func.isRequired,
  onOpenScheduleModal: T.func.isRequired,
};
